import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-c07a00c4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "pl50 mt50 pr50"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("b", {
  class: "title"
}, "发票详情 ", -1));
const _hoisted_3 = {
  class: "sub_title text_grey mt15 mb15"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "sub_title mt15 bold mb15"
}, "开票信息", -1));
const _hoisted_5 = {
  class: "open_invice_info flex_FSBC mt15 mb30"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flex_size_1"
}, [/*#__PURE__*/_createElementVNode("p", null, "受票方"), /*#__PURE__*/_createElementVNode("p", null, "纳税人识别号"), /*#__PURE__*/_createElementVNode("p", null, "开户行"), /*#__PURE__*/_createElementVNode("p", null, "发票类型"), /*#__PURE__*/_createElementVNode("p", null, "服务费用（元）")], -1));
const _hoisted_7 = {
  class: "flex_size_1"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flex_size_1"
}, [/*#__PURE__*/_createElementVNode("p", null, "受票方"), /*#__PURE__*/_createElementVNode("p", null, "地址"), /*#__PURE__*/_createElementVNode("p", null, "账号"), /*#__PURE__*/_createElementVNode("p", null, "服务项目"), /*#__PURE__*/_createElementVNode("p", null, "ㅤ")], -1));
const _hoisted_9 = {
  class: "flex_size_1"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "撮合服务", -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "ㅤ", -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "sub_title bold mt30"
}, "运单明细", -1));
const _hoisted_13 = {
  class: "flex_FCAC"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_el_table = _resolveComponent("el-table");
  const _component_el_pagination = _resolveComponent("el-pagination");
  const _component_el_config_provider = _resolveComponent("el-config-provider");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("p", _hoisted_3, " 发票申请号：" + _toDisplayString($setup.data.monthSettleServiceNo), 1), _hoisted_4, _createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("div", _hoisted_7, [_createElementVNode("p", null, _toDisplayString($setup.data.name), 1), _createElementVNode("p", null, _toDisplayString($setup.data.taxNo), 1), _createElementVNode("p", null, _toDisplayString($setup.data.openBank), 1), _createElementVNode("p", null, _toDisplayString($setup.invoiceTypeList[$setup.data.invoiceType]), 1), _createElementVNode("p", null, _toDisplayString($setup.data.amount / 100), 1)]), _hoisted_8, _createElementVNode("div", _hoisted_9, [_createElementVNode("p", null, _toDisplayString($setup.phoneDesc($setup.data.phone)), 1), _createElementVNode("p", null, _toDisplayString($setup.data.wordAddress), 1), _createElementVNode("p", null, _toDisplayString($setup.data.bankNo), 1), _hoisted_10, _hoisted_11])]), _hoisted_12, _createVNode(_component_el_table, {
    data: $setup.data.list,
    class: "mt15",
    "show-overflow-tooltip": "true"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_table_column, {
      prop: "name",
      label: "服务项目"
    }), _createVNode(_component_el_table_column, {
      prop: "loadingAddress",
      label: "类型"
    }, {
      default: _withCtx(() => [_createTextVNode(" 月度结算 ")]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      prop: "amount",
      label: "开票金额（元）"
    }, {
      default: _withCtx(scope => [_createTextVNode(_toDisplayString(scope.row.amount / 100), 1)]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      label: "支付订单号"
    }, {
      default: _withCtx(scope => [_createTextVNode(_toDisplayString(scope.row.outTradeNo), 1)]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      label: "开票时间"
    }, {
      default: _withCtx(scope => [_createTextVNode(_toDisplayString(scope.row.createTime ? $setup.moment(scope.row.createTime).format("YYYY-MM-DD HH:mm") : ""), 1)]),
      _: 1
    })]),
    _: 1
  }, 8, ["data"]), _createElementVNode("div", _hoisted_13, [_createVNode(_component_el_config_provider, {
    locale: $setup.zhCn
  }, {
    default: _withCtx(() => [_createVNode(_component_el_pagination, {
      "page-size": $setup.data.size,
      class: "mt20",
      background: "",
      layout: "pager,total",
      total: $setup.data.total,
      onCurrentChange: $setup.currentChange
    }, null, 8, ["page-size", "total", "onCurrentChange"])]),
    _: 1
  }, 8, ["locale"])])]);
}